/**
 * Cache invalidation for Vault writes the HOST makes on a plugin's behalf.
 *
 * The consent sheets (pick / save / promote) and the drop-to-grant dialog
 * change Vault state from the user's session, but they are host chrome — they
 * sit outside the Fias Files arche and its mutation hooks, so nothing
 * invalidated the lists those hooks feed. Fias Files opened within the
 * `staleTime` window then showed the old folder placement or the old "App
 * access" list: right after the user granted an app edit access is exactly
 * when that list has to be true.
 *
 * Uses the app's QueryClient directly rather than `useQueryClient()`: one of
 * the callers is a bridge callback, not a component, and these sheets also
 * render in hosts (and tests) with no provider above them.
 */
import { queryClient } from '@/lib/query-client';
import { queryKeys } from '@/lib/query-keys';

/**
 * Drop every cached Vault-documents view. Deliberately the whole branch: a
 * promote moves a file between folders AND changes its visibility, and a grant
 * changes both the per-document access list and the Arche Access page. These are
 * rare, user-confirmed events — precision here would buy nothing.
 */
export function invalidateVaultDocumentsAfterHostWrite(): void {
  void queryClient.invalidateQueries({ queryKey: queryKeys.vaultDocuments.all });
}
